import { render, staticRenderFns } from "./FilterWellnessDialog.vue?vue&type=template&id=11c32146&scoped=true"
import script from "./FilterWellnessDialog.vue?vue&type=script&lang=js"
export * from "./FilterWellnessDialog.vue?vue&type=script&lang=js"
import style0 from "./FilterWellnessDialog.vue?vue&type=style&index=0&id=11c32146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c32146",
  null
  
)

export default component.exports